import axios from 'axios';
import { tabulatorInstance } from './common/Controls/Tabulator';
import { debugLog } from './utils';
import { initializeAxios } from './data/fetch/Fetch';

export const initializeTabulator = () => {
	const tabulatorDefaults = tabulatorInstance.defaults;
	tabulatorDefaults.placeholder = "Data not available...";
	tabulatorDefaults.dataSendParams = {
		page: 'page',
		size: 'pageSize'
	}
	tabulatorDefaults.dataReceiveParams = {
		current_page: 'page',
		last_page: 'totalPages',
		per_page: 'pageSize'
	}

	tabulatorDefaults.ajaxFetch = (url: string): Promise<any> =>
		axios.get(url);
}

export function getBaseApiUrl(): string {
	const url = process.env.REACT_APP_RESTAPI_URL;
	if( url ) {
		return url;
	} else {
		const protocol = window.location.protocol || 'https:';
		return protocol + '//' + window.location.host + '/api/v2';	
	}
}

export type Application = {
	BaseApiUrl: string;
	Debug: boolean,
	RenderDebug: boolean,
} 

export const application: Application = {
	BaseApiUrl: getBaseApiUrl(),
	Debug: process.env.REACT_APP_TRACE === 'true' ? true : false,
	RenderDebug: process.env.REACT_APP_TRACE_RENDER === 'true' ? true : false,
}

export const initialize = () => {
	initializeTabulator();
	initializeAxios(getBaseApiUrl());
	debugLog(`Env: ${process.env.REACT_APP_ENV}`)
	debugLog(`Initialized: `, JSON.stringify(application));
}
